var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { LoadingAFY, position, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { useProductCreation } from "./hook/productCreation.hook";
import { ProductCreationView } from "./view/productCreation.view";
export var ProductCreation = function () {
    var productCreation = useProductCreation();
    return (_jsxs(React.Fragment, { children: [productCreation.seeToast.show &&
                showToast(position.topRight, productCreation.seeToast.type, productCreation.seeToast.message, productCreation.closeToast), _jsx(LoadingAFY, { loading: productCreation.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: productCreation.loadingText, textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(ProductCreationView, __assign({}, productCreation.view))] }));
};
export default ProductCreation;
